import app from 'flarum/forum/app'

const fetching: {
  [key: string]: Promise<any>
} = {};

export function hasPlayerData(id: string) {
  return (app.data.steamProfiles as SteamProfile)[id] !== undefined;
}

export function getPlayerData(id: string) {
  return (app.data.steamProfiles as SteamProfile)[id];
}

export function getOrLoadPlayerData(id: string): Promise<any> {
  if (fetching[id] !== undefined) return fetching[id];
  const p = new Promise<any>((resolve, reject) => {
    if (hasPlayerData(id)) resolve(getPlayerData(id));
    m.request({
      url: app.forum.attribute("baseUrl") + "/api/steam/player/" + id
    }).then((data: any) => {
      if (data.response.players[0]) {
        (app.data.steamProfiles as SteamProfile)[id] = data.response.players[0];
        resolve(getPlayerData(id));
      } else {
        reject(null);
      }
    }).catch(reject).finally(() => delete fetching[id]);
  });
  fetching[id] = p;
  return p;
}

